import {
  resetAgentACWState,
  setAgentACWState,
  setAgentCurrState,
  setCompleteAgentState,
  updateAgentCannedResponses,
  updateAgentGeoLocationAction,
} from "../actions/agent";
import { createMissedAgentStateAvailableNotification } from "../actions/notifications.ts";
import {
  answerCase,
  changeSelectedQueues,
  chatWrapup,
  emailWrapup,
} from "../api/session-api";
import { addNotificationAction } from "../connector/notifications.ts";
import {
  AGENT_AFTER_CALL_WORK_STATE_ID,
  API_CASE_ANSWER,
  CALL,
  CALLBACK,
  CHAT,
  EMAIL,
  STATE_CANNEDRESPONSES,
} from "../constants/constants";
import { STATE_ACW, STATE_AGENT } from "../constants/constants";
import { API_QUEUE_JOIN_UPDATE, STATE_AGENT_STATE_AVAILABLE_NOTIFICATION } from "../constants/events.ts";
import Emitter from "../emitter/index.ts";
import storeRTK from "../store/storeRTK";
import { AgentProfile } from "../types/agent.type.ts";
import { SessionEvent } from "../types/call.type.ts";
import { showErrorToast } from "../utils/utils.ts";
// import { caseHandler, updateActiveCaseTab } from "./cases.ts";

export function agentPresenceHandler(ev: any) {
  const allowedStates = storeRTK.getState().agent?.states?.allowedStates;
  const allStates = allowedStates.map((state: any) => state.id);
  if(ev && ev.id !== 'AfterCallWork' && allStates && allStates.length > 0) {
    const isAllowed = allStates.includes(ev.id);
    if(!isAllowed) {
      return;
    }
  }
  storeRTK.dispatch(setAgentCurrState(ev));
}

export function setCompleteAgentData(ev: AgentProfile) {
  storeRTK.dispatch(setCompleteAgentState(ev));
}

//storeRTK.dispatch(setInitialChatState(messageEnvelope.body.chat));

function afterCallWorkHandler(ev: SessionEvent<any>) {
  if (ev.success && ev.body) {
    if (ev.body.state === "PENDING") {
      if (
        ev.body.conversationMedia === CALL ||
        ev.body.conversationMedia === CALLBACK
      ) {
        const update = {
          acwState: {
            id: AGENT_AFTER_CALL_WORK_STATE_ID,
            displayName: "After Call Work",
          },
          acwStateModifiedDate: new Date().getTime(),
        };
        storeRTK.dispatch(setAgentACWState(update));
      } else if (ev.body.conversationMedia === CHAT) {
        const participantId = ev.body?.selfId;
        const conversationId = ev.body.conversationId;
        if (participantId && conversationId) {
          setTimeout(() => {
            chatWrapup({ participantId, conversationId });
          }, 0);
        } else {
          console.warn(
            "Either participantId or conversationId is missing during chat wrapup",
            ev
          );
        }
      } else if (ev.body.conversationMedia === EMAIL) {
        const participantId = ev.body?.selfId;
        const conversationId = ev.body.conversationId;
        if (participantId && conversationId) {
          setTimeout(() => {
            emailWrapup({ participantId, conversationId });
          }, 0);
        } else {
          console.warn(
            "Either participantId or conversationId is missing during email wrapup",
            ev
          );
        }
      }
    } else if (ev.body.state === "COMPLETE") {
      if (
        ev.body.conversationMedia === CALL ||
        ev.body.conversationMedia === CALLBACK
      ) {
        const update = {
          acwState: null,
          acwStateModifiedDate: 0,
        };
        storeRTK.dispatch(resetAgentACWState());
      } else if (ev.body.conversationMedia === CHAT) {
        //do nothing
      }
    }
  }
}
export function cannedResponseHandler(event: SessionEvent<any>) {
  if (event.body) {
    storeRTK.dispatch(updateAgentCannedResponses(event.body));
  }
}

export function updateAgentGeoLocation(data: { geoLocation: string }) {
  storeRTK.dispatch(updateAgentGeoLocationAction(data));
}
const agentStateAvailableNotificationHandler = (ev: SessionEvent<any>) => {
  console.log("Agent state available notification event in controller: ", ev);
  
  // Create missed call notification
  const notification = createMissedAgentStateAvailableNotification();
  
  console.log("Created notification: ", notification);
  
  // Dispatch the notification to the Redux store
  const action = addNotificationAction(notification);
  
  try {
    storeRTK.dispatch(action);
    console.log("Action dispatched successfully");
  } catch (error) {
    console.error("Error dispatching action: ", error);
  }
  
  // Also display a persistent toast notification
  showErrorToast("Agent state changed to Not Ready due to missed contact.", "agentStateAvailableNotification", 1*60*60*1000); // 1 hour
};

export default function registerAgentHandlers() {
  Emitter.on(STATE_AGENT, agentPresenceHandler);
  Emitter.on(API_CASE_ANSWER, answerCase);
  Emitter.on(STATE_ACW, afterCallWorkHandler);
  Emitter.on(STATE_CANNEDRESPONSES, cannedResponseHandler);
  Emitter.on(API_QUEUE_JOIN_UPDATE, changeSelectedQueues)
  Emitter.on(STATE_AGENT_STATE_AVAILABLE_NOTIFICATION, agentStateAvailableNotificationHandler); // For agent state available notification
}
